<template>
  <ul>
    <li>Maîtrise des apports caloriques</li>
    <li>Contrôle des apports en féculents, produits sucrés et alcool pour lisser la glycémie</li>
  </ul>
</template>

<script>
export default {
  name: "DiabeteSummary",
  props: [],
  data: () => ({}),
  computed: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss"></style>
